export function isNil(value: unknown): value is null | undefined {
    return value === null || typeof value === 'undefined';
}

export function convertToTitleCase(source: string): string {
    if (!source || source.length === 0) {
        return '';
    }

    const titleCaseString = source.toLowerCase().split(' ');
    for (let i = 0; i < titleCaseString.length; i++) {
        titleCaseString[i] = titleCaseString[i].charAt(0).toUpperCase() + titleCaseString[i].slice(1);
    }
    return titleCaseString.join(' ');
}

export function dropQueryParams(source: string): string {
    if (!source || source.length === 0) {
        return '';
    }

    const trimmedString = source.split('?', 1);

    return trimmedString[0];
}

export function getQueryParamsAsObject(url: string): Record<string, string> {
    if (!url || url.length === 0) {
        return {};
    }

    const splitUrl = url.split('?');

    if (splitUrl.length <= 1) {
        return {};
    }
    const splitParams = splitUrl[1].split('&');
    if (splitParams.length < 1) {
        return {};
    }

    const queryParamsAsObject: Record<string, string> = {};
    splitParams.forEach((param) => {
        const keyValue = param.split('=');
        queryParamsAsObject[keyValue[0]] = keyValue[1];
    });
    return queryParamsAsObject;
}

export function hasOnlyNumbers(source: string): boolean {
    const numbersOnly = /^\d+$/;
    return !!source.match(numbersOnly);
}
